import localeText from "../../../../locale";
import "./style.css";

const LandingCopyright = () => {
  const images = [
    { src: "paypal.png", id: 1 },
    { src: "visa.png", id: 2 },
    { src: "masterCard.png", id: 3 },
    { src: "expressoAmericano.png", id: 4 },
  ];
  const partners = [
    { src: "cryptosmart.jpg", url: "https://cryptosmart.it/", id: 1 },
    { src: "fondoSanMarco.jpg", url: "https://fondosanmarco.it/", id: 2 },
    { src: "grupoG8.jpg", url: "#", id: 3 },
    { src: "confirmea.jpg", url: "https://www.confimea-sanita.org", id: 4 },
    { src: "benesse.png", url: "https://benesserealcalinobio.com/", id: 5 },
    { src: "maticom.png", url: "https://www.maticom.it/", id: 6 },
    { src: "attiva-piu.png", url: "https://www.attivapiu.it/", id: 7 },
    { src: "jimmyk.png", url: "https://www.jimmyk.it", id: 8 },
  ];
  return (
    <footer>
      <section className="md:py-5 py-4" style={{ backgroundColor: "#ffffff", color: "var(--extra-body)" }}>
        <div className="flex flex-wrap justify-content-between gap-6 mb-5">
          <div className="flex flex-column gap-3">
            <div className="font-bold text-sm">{localeText("paymentMethods")}</div>
            <div className="flex flex-wrap gap-4">
              {images.map((image) => (
                <div key={image.id} className="flex align-items-center">
                  <img
                    src={require(`../../../images/${image.src}`)}
                    alt={image.src}
                    style={{ width: "100%", maxWidth: "70px", maxHeight: "40px" }}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-column gap-3">
            <div className="font-bold text-sm">{localeText("shippingMethods")}</div>
            <div>
              <img
                src={require("../../../images/logo-iospedisco.png")}
                alt="iO Spedisco"
                style={{ maxWidth: "150px" }}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-column gap-3">
          <div className="font-bold text-sm">{localeText("partners")}</div>
          <div className="flex flex-wrap align-items-center gap-5">
            {partners.map((partner) => (
              <a
                key={partner.id}
                href={partner.url}
                target="_blank"
                rel="noreferrer"
                className="flex align-items-center partner-logo"
              >
                <img
                  src={require(`../../../images/parcerias/${partner.src}`)}
                  alt={partner.src}
                  style={{ maxHeight: "48px" }}
                />
              </a>
            ))}
          </div>
        </div>
      </section>
    </footer>
  );
};

export default LandingCopyright;
